module.exports = __webpack_public_path__ + "img/gif_fan.60b76bd1.gif";